export {
    availableClients,
    getAvailableClients,
    populateRecipientsList,
    resetAvailableClients,
    setAvailableClients,
    updateRecipientsLists,
} from './available-clients';

export {
    addClient,
    addClientButtonListener,
    addClientWithRole,
    buildClientSummaryTextLine,
    syncClientInfoState,
    buildClientTextLine,
    clearClients,
    clearMainFormClients,
    disableClientInputs,
    EDIT_CLIENT_FIELDS,
    enableClientInputs,
    getAllClientInputs,
    getClientsFromEnabledEmailInputs,
    getEditedClientId,
    handleEditedFormClient,
    initFormValidation,
    prepareModalForFormClientEditing,
    removeClient,
    resetTelInputErrors,
    setClientTextToSummaryTextLine,
    setEditedClientId,
    setEmailValidation,
    setPhoneValidation,
    toggleDisabledOnClientInputs,
    validateTelInput,
} from './form-clients';

export { clearFormControlErrorMessageHandler, initClearFormErrors } from './clear-form-errors';

export { clientInfoErrors, handleServerErrorResponse } from './handle-form-errors';

export {
    ADD_CLIENT_FORM_SELECTOR,
    getBranchSelector,
    getCompanySelector,
    getWireDocRecipientsSelector,
    getWireDocSelector,
    REQUEST_BANK_INFO_SELECTOR,
    REQUEST_IDV_SELECTOR,
    WIRE_DOC_RECIPIENTS_SELECTOR,
} from './selectors';

export { buildDataIdSelector, getDataIdAttribute, joinFormIdAndSelector } from './add-file-utils';

export {
    clearESignEditFields,
    handleEmailChangeForSigners,
    populateDocumentSignersList,
    populateNewFileDocumentClients,
    refreshSelectionOrder,
    selectionOrder,
    updateSignerSelections,
} from './add-file-documents';

export { runAddFileSubmitCallbacks } from './add-file-reset';

export { fileSubmissionErrors } from './submission-error';

// If ScriptRegistry is available, register this script
window.ScriptRegistry?.register(window.ScriptRegistry.knownScripts.addFile);
